// src/pages/IndoorMap/RoomMarkers.jsx
import React from "react"
import { MAP_VIEWBOX, ROOM_POINTS } from "./mapData"

// Parse viewBox "0 0 1600 900" -> [1600, 900] so marker coordinates can be
// converted to percentages of the stage, keeping buttons pinned to the map
// image at any render size.
const [, , VB_W, VB_H] = MAP_VIEWBOX.split(" ").map(Number)

// Purely presentational: role for each button ("idle" | "pickable" | "start" |
// "end" | "disabled") is computed by the parent from startRoom/endRoom and
// passed in via getDotRole, so this component holds no state of its own.
const RoomMarkers = ({ rooms, getDotRole, onDotClick }) => {
  return (
    <div className="room-markers-overlay">
      {rooms.map(room => {
        const point = ROOM_POINTS[room.id]
        if (!point) return null // no known map position for this room yet

        const role = getDotRole(room.id)
        const clickable = role !== "disabled"

        const handleActivate = () => {
          if (clickable) onDotClick(room.id)
        }

        return (
          <button
            key={room.id}
            type="button"
            className={`room-marker-btn room-marker-btn--${role}`}
            style={{
              left: `${(point.x / VB_W) * 100}%`,
              top: `${(point.y / VB_H) * 100}%`,
            }}
            onClick={handleActivate}
            disabled={!clickable}
            aria-label={`${room.label}${clickable ? "" : " (unavailable)"}`}
          >
            {room.label}
          </button>
        )
      })}
    </div>
  )
}

export default RoomMarkers